import config from "../../config/config";
const state = {
    fullname: '',
    profileImg: '',
    topic: "topic",
    permission : null,
    main: {
        name: 'NBTC',
        position: 'Operator',
        state: {
            color: '#3c763d',
            name: 'Online'
        },
        createdAt: new Date()
    },
    manage_menu: [{
            menu: 'Manage_user',
            menu_name: "เมนูจัดการผู้ใช้งาน (User)"
        },
        {
            menu: 'Manage_admin',
            menu_name: "เมนูจัดการสิทธิผู้ดูแลระบบ (Admin)"
        },
        { 
            menu: 'Manage_operator',
            menu_name: "เมนูจัดการสิทธิผู้ให้บริการ (Operator)" 
        },
        {
            menu: 'Typegroup',
            menu_name: "เมนูการจัดกลุ่มบริษัทผู้ให้บริการ"
        },
        {
            menu: 'ListOperator',
            menu_name: "เมนูจัดการรายชื่อบริษัทของผู้ให้บริการ"
        },
        {
            menu: 'Manage_average',
            menu_name: "เมนูจัดการอัตราค่าบริการเพื่อการกำกับดูแล"
        },
        {
            menu: 'Manage_service',
            menu_name: "เมนูจัดการข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่"
        },
        {
            menu: 'Manage_mobile_service',
            menu_name: "จัดการสัดส่วนรายการส่งเสริมการขาย โปรวินาที และ โปรนาที"
        },
        {
            menu: 'Manage_terms_and_condition',
            menu_name: "เมนูจัดการเงื่อนไขการให้บริการ"
        },
        {
            menu: 'Manage_privacy_data_policy',
            menu_name: "เมนูจัดการข้อกำหนดและนโยบายข้อมูลส่วนบุคคล"
        },
        {
            menu: 'Manage_security_policy',
            menu_name: "เมนูจัดการนโยบายด้านความปลอดภัย"
        },
        {
            menu: 'Manage_cookie_privacy',
            menu_name: "เมนูจัดการนโยบายคุกกี้"
        },
        {
            menu: 'Manage_question',
            menu_name: "เมนูจัดการคำถามที่พบบ่อย"
        },
        {
            menu: 'Manage_article',
            menu_name: "เมนูจัดการบทความ"
        },
        {
            menu: 'Manage_news',
            menu_name: "เมนูจัดการข่าวสาร"
        },
        {
            menu: 'Manage_banner',
            menu_name: "เมนูจัดการป้ายโฆษณา (Banner)"
        },
        {
            menu: 'Manage_mobile',
            menu_name: "เมนูจัดการรายงานการส่งเสริมข้อมูลโทรศัพท์เคลื่อนที่"
        },
        {
            menu: 'Manage_internet',
            menu_name: "เมนูจัดการรายงานการส่งเสริมข้อมูลอินเทอร์เน็ตประจำที่"
        },
        {
            menu: 'Manage_request_mobile',
            menu_name: "เมนูจัดการคำร้องของผู้ให้บริการโทรศัพท์เคลื่อนที่"
        },
        {
            menu: 'Manage_request_internet',
            menu_name: "เมนูจัดการคำร้องของผู้ให้บริการอินเทอร์เน็ตประจำที่"
        },
        {
            menu: 'Manage_data',
            menu_name: "เมนูจัดเก็บข้อมูลจากเว็บไซต์ผู้ให้บริการ"
        },
        {
            menu: 'Upload_save',
            menu_name: "เมนูนำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกับกำดูแล"
        },
        {
            menu: 'Report_promotion_mobile_type',
            menu_name: "เมนูรายงานจำนวนรายการส่งเสริมการขายบริการโทรศัพท์เคลื่อนที่จำแนกตามประเภทบริการ"
        },
        {
            menu: 'Services_rate',
            menu_name: "เมนูรายงานอัตราค่าบริการต่างๆของบริการโทรศัพท์เคลื่อนที่"
        },
        {
            menu: 'Program_technologies',
            menu_name: "เมนูรายงานตารางอัตราค่าบริการเฉลี่ยของการกำกับดูแลและอัตราค่าบริการเฉลี่ยบริการโทรศัพท์เคลื่อนที่ของแต่ละผู้ให้บริการ"
        },
        {
            menu: 'Services_change',
            menu_name: "เมนูรายงานการเปลี่ยนแปลงอัตราค่าบริการเฉลี่ยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล"
        },
        {
            menu: 'Pro_seconds_G5',
            menu_name: "เมนูรายงานตารางรายการส่งเสริมการขายที่เสนอขายในตลาด (โปรวินาทีต้องไม่น้อยกว่า 50%)"
        },
        {
            menu: 'Promotion_table_avg',
            menu_name: "รายงานตารางรายการส่งเสริมการขาย ค่าเฉลี่ยค่าบริการและการเปลี่ยนแปลงอัตราค่าบริการในไตรมาส"
        },
        {
            menu: 'Promotion_percent',
            menu_name: "เมนูรายงานร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของแต่ละผู้ให้บริการ"
        },
        {
            menu: 'Services_trends',
            menu_name: "เมนูรายงานแนวโน้มอัตราค่าบริการโปรวินาทีและโปรนาทีของแต่ละผู้ให้บริการ"
        },
        {
            menu: 'Fast_internet_home_G9',
            menu_name: "เมนูรายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยีต่างๆ"
        },
        {
            menu: 'Services_internet',
            menu_name: "เมนูรายงานจำนวนรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยีต่างๆ ของแต่ละผู้ให้บริการ"
        },
        {
            menu: 'Fast_internet_home_G11',
            menu_name: "เมนูรายงานอัตราค่าบริการอินเทอร์เน็ตความเร็วสูงประจำที่"
        },
        {
            menu: 'Fast_internet_home_G12',
            menu_name: "เมนูรายงานอัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่่"
        },
        {
            menu: 'Reportview_promotion',
            menu_name: "เมนูรายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ"
        },
        {
            menu: 'Report_blockchain',
            menu_name: "รายงานแสดงการรับ-ส่งข้อมูลในบล็อกเชน (BlockChain)"
        },
        
        {
            menu: 'Popular_proMobile',
            menu_name: "โปรโมชันเด่นของบริการโทรศัพท์เคลื่อนที่"
        },
        {
            menu: 'Popular_proInternet',
            menu_name: "โปรโมชันเด่นของบริการอินเทอร์เน็ตประจำที่"
        },
        {
            menu: 'Access_log',
            menu_name: "ประวัติการเข้าใช้งาน (Access Logs)"
        },
        {
            menu: 'Report_promotion_ranking',
            menu_name: "รายงานจัดอันดับรายการส่งเสริมการขาย (Promotion ranking)"
        },
        {
            menu: 'User_behavior',
            menu_name: "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ "
        },
        {
            menu: 'Uteleme',
            menu_name: "รายงานพฤติมาตร"
        }
    ],
    menu: []
}

const actions = {
    setCookie({ commit }, data) {
        let result = $cookies.get("user_nbtc");
        state.fullname = result.fullname;
        state.profileImg = config.API_URL + result.profileImg;
        state.permission = JSON.parse(atob($cookies.get("user_nbtc").permission))
    }
}

const mutations = {

}

export const Menu = {
    namespaced: true,
    state,
    actions,
    mutations
}

function newFunction() {
    return 32;
}
